<template>
  <div>
    <Ibox back="true" titulo="Agregar Tarea">
      <FormGroup cols="3" label="Nombre">
        <input class="form-control" type="text" v-model="tarea.nombre_tarea">
      </FormGroup>
      <FormGroup cols="3" label="Plazo">
        <Datepicker input-class="form-control" format="dd-MM-yyyy" v-model="tarea.plazo" placeholder="Seleccione una fecha"></Datepicker>
      </FormGroup>
      <FormGroup cols="3" label="Categoría" :is_loading="is_loading_categorias">
        <v-select
            placeholder="Seleccione una categoría"
            :options="options_categorias"
            :clearable=false
            :reduce="categoria=>categoria.id_categoria"
            label="nombre_categoria"
            v-model="tarea.id_categoria">
        </v-select>
      </FormGroup>
      <FormGroup
          :is_loading="is_loading_categorias"
          cols="3"
          label="Nueva categoría">
        <b-button style="padding-top:2px; padding-bottom:2px" v-if="utils.tienePermiso()" variant="primary" v-on:click="modalNuevaCat()">Agregar categoría</b-button>
      </FormGroup>
      <FormGroup cols="12" label="Descripcion">
        <textarea v-model="tarea.desc_tarea" class="md-textarea form-control" rows="4"></textarea>
      </FormGroup>
      <form-group cols="4" label="Progreso">
        <CheckBox v-model='tarea.act_progreso' @update-value="update"></CheckBox>
      </form-group>
      <b-col cols="12">
        <b-card class="mb-2" header="Ayuda" header-bg-variant="success" header-text-variant="white">
          <b-card-text>
            <!--<p>En este menú debe seleccionar quien va a realizar la tarea. </p>-->
            <p>En la lista de usuarios puede seleccionar quienes supervisaran la tarea con el permiso de “Ver” y quien realizara la tarea con el permiso de “Realizar”.</p>
            <p>En la lista de empresas puede seleccionar cual empresa realizara la tarea.</p>
          </b-card-text>
        </b-card>
      </b-col>
      <b-col cols="6" style="padding-right:3px">
        <b-card 
          class="mb-2" 
          title="Usuarios" >
          <DataTable
            :loading="is_loading"
            :columns="columns"
            :rows="rows"
            :buttons="false"
            :searching="false"
            clases="table-bordered table-hover table-condensed nowrap">
          <template slot="table-row" slot-scope="props">
            <span v-if="props.column.field =='permiso'">
              <v-select
                  :ref="'permiso_'+props.row.id_usuario"
                  :value="usuarios[props.row.id_usuario]"
                  :options="permisos"
                  :reduce="permiso=>permiso.v"
                  @input="permiso=>setSelectedPermiso(props.row.id_usuario,permiso)">
              </v-select>
            </span>
            <span v-else>
              {{ props.formattedRow[props.column.field] }}
            </span>
          </template>
        </DataTable>
        </b-card>
      </b-col>
      <b-col cols="6" style="padding-left:3px">
        <b-card class="mb-2" title="Empresas">
          <DataTable
              :loading="is_loading"
              :columns="columns_empresa"
              :rows="rows_empresa"
              :buttons="false"
              :searching="false"
              clases="table-bordered table-hover table-condensed nowrap">
            <template slot="table-row" slot-scope="props">
              <span v-if="props.column.field == 'action'">
                <a v-if="props.row.id_empresa==tarea.id_empresa" style="color:red" v-on:click="asignarEmpresa(props.row.id_empresa)" >Quitar</a>
                <a v-else class="primary" v-on:click="asignarEmpresa(props.row.id_empresa)" >Asignar</a>
              </span>
              <span v-else>
                {{props.formattedRow[props.column.field]}}
              </span>
            </template>
          </DataTable>
        </b-card>
      </b-col>
      <b-col v-if="utils.tienePermiso()" cols="12" align="right">
        <b-button v-if="is_loading" variant="primary">
          <Loading :size="'1'" :text="'Cargando usuarios'"/>
        </b-button>
        <b-button v-else-if="!is_adding" variant="primary" v-on:click="agregarTarea()">Agregar Tarea</b-button>
        <b-button v-else variant="primary">
          <Loading :size="'1'" :text="'Agregando tarea'"/>
        </b-button>
      </b-col>
    </Ibox>
    <b-modal hide-footer ref="modal_nuevaCat" title="Agregar categoría">
      <FormGroup cols="12" label="Nombre categoría">
        <input class="form-control" v-model="nueva_cat.nombre_categoria" placeholder="Obligatorio">
      </FormGroup>
      <FormGroup cols="12" label="Descripción">
        <textarea class="form-control" rows="4" maxlength="500" v-model="nueva_cat.desc_categoria" placeholder="No obligatorio"></textarea>
      </FormGroup>
      <b-button v-if="is_adding_cat" style="width:100%" variant="primary"><Loading :size="'1'" :text="'Agregando'"/></b-button>
      <b-button v-else variant="primary" style="width:100%" v-on:click="agregarCat">Agregar</b-button>
    </b-modal>
  </div>
</template>

<script>
import {empresaService, tareaService, userService} from "@/services";
import {utils} from "@/helpers";

export default {
  name: "ScreenTareasAgregar",
  data() {
    return {
      tarea:{
        nombre_tarea: '',
        desc_tarea: '',
        id_categoria: '',
        arr_usuario: '',
        act_progreso: false,
        plazo: '',
        id_cliente: userService.getUser().id_cliente,
        id_usuario: userService.getUser().id_usuario,
        id_empresa:''
      },
      utils,
      nueva_cat: {
        id_cliente: userService.getUser().id_cliente,
        nombre_categoria: '',
        desc_categoria:''
      },
      is_adding_cat:false,
      is_loading: true,
      is_adding: false,
      is_loading_categorias: true,
      options_categorias: [],
      usuarios: {},
      permisos: [{v: null, label: 'Sin asignar'}, {v: '0', label: 'Ver'}, {v: '1', label: 'Realizar'}],
      columns: [
        {label: 'Nombre Usuario', field: 'nombre_usuario'},
        {label: 'Correo', field: 'usuario'},
        {label: 'Permiso', field: 'permiso'},
      ],
      columns_empresa: [
        {label: 'Nombre empresa', field: 'nombre_empresa'},
        {label: 'Accion', field: 'action'},
      ],
      rows: [],
      rows_empresa: [],
      json_meta: [
        [{
          "key": "charset",
          "value": "utf-8"
        }]
      ],
    }
  },
  mounted() {
    this.cargarCategorias();
    this.cargarUsuarios();
    this.cargarEmpresas();
  },
  methods: {
    update(active) {
      this.tarea.act_progreso = active;
    },
    cargarEmpresas(){
      this.is_loading = true;

      empresaService.getEmpresa(
          userService.getUser().id_empresa, 'S'
      ).then(data => {
        this.rows_empresa = data.data;

        if(this.rows.length > 0){
          this.is_loading = false;
        }
      });
    },
    cargarCategorias() {
      var data = {
        'id_cliente': userService.getUser().id_cliente,
        'habilitado': 'S',

      };
      this.is_loading_categorias = true;
      tareaService.getCategoriaTarea(data).then(data => {
        this.options_categorias = data.data;
        this.is_loading_categorias = false;
      });
    },
    cargarUsuarios() {
      this.is_loading = true;
      tareaService.getUsuariosTarea({'id_cliente': userService.getUser().id_cliente,'id_empresa':userService.getUser().id_empresa}).then(data => {
        this.rows = data.data;
        for (var i = 0; i < this.rows.length; i++) {
          this.$set(this.usuarios, this.rows[i].id_usuario.toString(), this.rows[i].permiso);
        }
        if(this.rows_empresa.length > 0){
          this.is_loading = false;
        }
      });
    },
    setSelectedPermiso(id_usuario, permiso) {
      if(permiso == 1 && this.tarea.id_empresa){
        this.$confirm("Esto quitará a la empresa asignada").then((confirm) => {
          if(confirm){
            this.usuarios[id_usuario] = permiso;
            this.tarea.id_empresa = '';
            this.$refs['permiso_'+id_usuario].open = false;
          }
        });
      }else{
        this.usuarios[id_usuario] = permiso;
      }

    },
    agregarTarea() {
      this.asignarUsuarios();
      if (this.tarea.arr_usuario.length == 0) {
        utils.alerta({'msg': 'Debe asignar a lo menos un usuario', 'status': 'warning'});
      } else if ( !this.tarea.arr_usuario.some((element) => element.permiso == 1) && !this.tarea.id_empresa ) {
        utils.alerta({'msg': 'Debe asignar un usuario con el permiso necesario para realizar la tarea o asignar a una empresa contratista', 'status': 'warning'});
      } else if (this.tarea.nombre_tarea && this.tarea.desc_tarea && this.tarea.id_categoria && this.tarea.plazo ) {
        this.is_adding = true;
        tareaService.postTarea(this.tarea).then(respuesta => {
          utils.alerta({'msg': respuesta.msg, 'status': respuesta.status});
          this.is_adding = false;
          if (respuesta.status == "success") {
            this.$router.go(-1);
          }
        });
      } else {
        utils.alerta({'msg': 'Debe completar datos obligatorios', 'status': 'warning'});
      }
    },
    asignarEmpresa(id_empresa){
      if (this.tarea.id_empresa == id_empresa){
        this.tarea.id_empresa = '';
      }else if(Object.values(this.usuarios).some((element) => element == 1)) {
        this.$confirm("Esto quitará a los usuarios con el permiso realizar de la tarea").then((confirm) => {
          if(confirm){
            this.tarea.id_empresa = id_empresa;
            for (var i = 0; i < Object.keys(this.usuarios).length; i++) {
              var j = Object.keys(this.usuarios)[i];
              if (this.usuarios[j] == 1) {
                this.usuarios[j] = null;
              }
            }
          }
        });
      }else{
        this.tarea.id_empresa = id_empresa;
      }
    },
    asignarUsuarios(){
      this.tarea.arr_usuario = [];
      for (var i = 0; i < Object.keys(this.usuarios).length; i++) {
        var j = Object.keys(this.usuarios)[i];
        if (this.usuarios[j] != null) {
          this.tarea.arr_usuario.push({"id_usuario": j, "permiso": this.usuarios[j]});
        }
      }
    },
    modalNuevaCat(){
      this.$confirm("¿Está seguro que la categoría no se encuentra en la lista y desea agregarla?").then(() => {
        this.$refs['modal_nuevaCat'].show();
      });
    },
    agregarCat(){
      if(this.nueva_cat.nombre_categoria) {
        this.is_adding_cat = true;

        tareaService.postCategoria(this.nueva_cat).then(respuesta => {
          utils.alerta({'msg':respuesta.msg,'status':respuesta.status});
          this.is_adding_cat = false;
          if (respuesta.status == 'success') {
            this.nueva_cat.nombre_categoria = '';
            this.nueva_cat.desc_categoria = '';
            this.cargarCategorias();
            this.$refs['modal_nuevaCat'].hide();
          }
        });
      }else{
        utils.alerta({'msg': 'Debe ingresar un nombre', 'status': 'warning'});
      }
    }
  }
}
</script>